import SvgIcon from "@mui/material/SvgIcon";
import React from "react";

export const ExpandIcon = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: 24 }}>
    <circle cx="12" cy="12" r="11" fill="#eee" />
    <path
      fill="#aaa"
      d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6 1.41-1.41z"
    />
  </SvgIcon>
);
